import { SPORTSBOOK_HISTORY_HIDDEN_STORAGE_KEY } from '../policies/sportsbookHistory.policy.js';

const resolveStorage = () => {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

export const readHiddenSportsbookHistoryIds = (storage = resolveStorage()) => {
  if (!storage) return new Set();
  try {
    const parsed = JSON.parse(storage.getItem(SPORTSBOOK_HISTORY_HIDDEN_STORAGE_KEY) || '[]');
    return new Set(Array.isArray(parsed) ? parsed.filter((value) => typeof value === 'string' && value.trim() !== '') : []);
  } catch {
    return new Set();
  }
};

export const writeHiddenSportsbookHistoryIds = (historyIds, storage = resolveStorage()) => {
  if (!storage) return false;
  const values = [...historyIds].filter((value) => typeof value === 'string' && value.trim() !== '');
  try {
    storage.setItem(SPORTSBOOK_HISTORY_HIDDEN_STORAGE_KEY, JSON.stringify(values));
    return true;
  } catch {
    return false;
  }
};

export const getSportsbookHistoryHideId = (row) =>
  typeof row?.history_id === 'string' ? row.history_id : '';

const TERMINAL_HISTORY_STATUSES = new Set([
  'WON',
  'HALF_WIN',
  'PARTIAL_WON',
  'LOST',
  'HALF_LOSE',
  'PARTIAL_LOST',
  'PARTIAL',
  'VOID',
  'CANCELLED',
  'REJECTED',
  'FAILED',
]);

const normalizeHistoryStatus = (value) => {
  const status = String(value || '').trim().toUpperCase();
  if (status === 'HALF_LOSS') return 'HALF_LOSE';
  if (status === 'CANCELED') return 'CANCELLED';
  return status;
};

export const canHideSportsbookHistoryRow = (row) =>
  TERMINAL_HISTORY_STATUSES.has(
    normalizeHistoryStatus(row?.display_status || row?.status),
  );
